export const ITEM = 'Item';
//# sourceMappingURL=ITEM.js.map